<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, dotter
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://www.marvin-carstensen.com"
                class="nav-link text-muted"
                target="_blank"
              >Marvin Carstensen</a>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link text-muted"
                :to="{ name: 'Default' }"
              >
                Datenschutz
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link text-muted"
                :to="{ name: 'Default' }"
              >
                Impressum
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
